<template>
  <div class="security-check-container">
    <div class="container mx-auto px-4 py-8">
      <div class="mb-6">
        <h1 class="text-3xl font-bold mb-2">{{ $t('security_check.title') }}</h1>
        <p class="text-gray-600">{{ $t('security_check.description') }}</p>
      </div>
      
      <!-- 防伪查询外部网站内容 -->
      <div class="bg-white shadow-lg rounded-lg overflow-hidden border border-gray-200">
        <div class="iframe-container">
          <iframe 
            :src="securityCheckUrl" 
            title="防伪查询" 
            class="w-full h-[70vh] border-0"
            loading="lazy"
          ></iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue';

// 防伪查询外部链接
const securityCheckUrl = ref('http://chaxun.hzcg315.com/wscan.aspx?u=4304');
</script>

<style scoped>
.security-check-container {
  min-height: 70vh;
  background-color: #f9fafb;
}

.iframe-container {
  position: relative;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .iframe-container iframe {
    height: 80vh;
  }
}
</style>